import { StoryblokServerComponent } from "@storyblok/react/rsc";
import { Icon } from "~components/ui";
import type { MarketingMessageProps } from "./types";

function MarketingMessage({
  blok,
  ...context
}: Readonly<MarketingMessageProps>) {
  const icon = blok.iconName;
  const message = blok.message[0];

  return (
    <aside
      className="flex items-center justify-center gap-xs p-xs text-center text-default-sm"
      style={{
        background: blok.background ?? "inherit",
        color: blok.color ?? "inherit",
      }}
    >
      {icon && (
        <Icon name={icon} weight="duotone" className="shrink-0" size="20" />
      )}

      {message && (
        <StoryblokServerComponent
          blok={message}
          key={message._uid}
          {...context}
        />
      )}
    </aside>
  );
}

export { MarketingMessage };
